import { getResponse } from '@satellite/services/serviceUtilities';

/**
 * options: { fields: string[], joins: string[], includeMetaData: boolean }
 */

/**
 * @typedef {Object} AuthServiceOptions
 * @property {string[]} fields
 * @property {string[]} joins
 * @property {boolean} includeMetaData
 */
// TODO: Add return types here when time permits
export default {
  /**
   * @param {AuthServiceOptions} [options]
   * @param {import('axios').AxiosRequestConfig} [requestConfig]
   * @returns {Promise<Object>}
   */
  async getMe(options = {}, requestConfig = {}) {
    const response = await axios.get(`auth/me`, { ...requestConfig });
    return getResponse(response, options);
  },

  /**
   * @param {{ email: string, password: string }} params
   * @param {AuthServiceOptions} [options]
   * @returns {Promise<Object>}
   */
  async login(params, options = {}) {
    const response = await axios.post(`auth/login`, params);
    return getResponse(response, options);
  }
};
